import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios';
import { BASE_URL } from '../api/api';
import { useCookies } from 'react-cookie';
import { useLocation } from "react-router-dom";
import '../styles/Tablist.scss'

import EditPen from "../assets/icons/edit-pen.svg"
import UploadIcon from "../assets/icons/upload.svg"

// import Context 
import { ContentUploaderFormDisplay } from '../context/ContentUploaderDisplay';
import { TabAdderDisplay } from '../context/TabAdderDisplay';
import { EditTabNameDisplay } from '../context/EditTabNameDisplay';
import { TabData } from '../context/TabData';
import { Auth } from '../context/Auth';

const Tablist = ({ ownerUserId, fetchContentData }) => {
    // const navigate = useNavigate();
    const [cookies, setCookie] = useCookies(['token', 'userId', 'isLoggedIn', 'channelId']);
    const contentUploaderFormDisplay = useContext(ContentUploaderFormDisplay);
    const tabAdderDisplay = useContext(TabAdderDisplay);
    const editTabNameDisplay = useContext(EditTabNameDisplay);
    const tabData = useContext(TabData);
    const auth = useContext(Auth);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idFromUrl = queryParams.get('id');

    const [tabItem, setTabItem] = useState([]);
    const [owner, setOwner] = useState(false);
    const [activeTabDetails, setActiveTabDetails] = useState({ title: "" });

    const handleAddNewTab = () => {
        tabAdderDisplay.showTabAdderFormDispatch({ type: 'openAddTabForm' })
    }

    const handleUploadInTab = () => {
        contentUploaderFormDisplay.showContentUploaderFormDispatch({ type: 'openContentUploaderForm' });
    }

    const handleTabNameEdit = (e, id, tabName) => {
        // e.stopPropagation();
        // e.preventDefault();
        editTabNameDisplay.showEditTabNameFormDispatch({ type: 'openEditTabNameForm' });
        tabData.tabDataReducerDispatch({ type: 'updateTabData', payload: { id: id, tabName: tabName } });
    }

    useEffect(() => {
        // Get the userId from context, then fetch the channel Id owned by it and then compare it with the "id" present in search URL
        if (auth.authState.userId) {
            axios.post(`${BASE_URL}/api/auth/fetch-user-details`, { userId: auth.authState.userId })
                .then(res => {
                    console.log(res, "fetch User in Hidden Component");
                    if (res.data.statusText === "success") {
                        if (res.data.user.channelId === idFromUrl) {
                            setOwner(true);
                        }
                    }
                })
                .catch(err => console.log(err))
        } else {
            setOwner(false);
        }

        axios.get(`${BASE_URL}/api/tabs/${idFromUrl}`)
            .then(res => {
                // console.log(res, "Fetched tabs response")
                if (res.data.statusText === "success") {
                    setTabItem([...res.data.tabs]);
                    setActiveTabDetails(res.data.tabs[0]);
                    window.sessionStorage.setItem("activeTabDetail", JSON.stringify(res.data.tabs[0]));
                    //Call function of Parent Component for updating the content on profile
                    fetchContentData();
                }
            })
            .catch(err => console.log(err, "Error! fetching Tabs"))
    }, [idFromUrl, tabAdderDisplay.displayTabAdderFormState, tabData.updatedTabDataState.reRenderTablist]);

    const handleTabClick = (tabDetail) => {
        setActiveTabDetails(tabDetail);
        window.sessionStorage.setItem("activeTabDetail", JSON.stringify(tabDetail));
        //Call function of Parent Component for updating the content on profile
        fetchContentData();
    }

    // console.log(activeTabDetails, "activeTabDetails");

    useEffect(() => {
        if (activeTabDetails) {
            const uploadButton = document.getElementById("tablist__long-title");

            if (uploadButton) {
                if (activeTabDetails.title.length >= 25) {
                    uploadButton.classList.add("tablist__long-title-animate");
                } else {
                    uploadButton.classList.remove("tablist__long-title-animate");
                }
            }
        }
    }, [activeTabDetails]);


    return (
        <div className='tablist'>
            <div className='tablist__tab-group'>
                {
                    tabItem.length !== 0 && tabItem.map((tab, index) => <button key={tab.title + index} className={activeTabDetails.id === tab.id ? 'tablist__tab tablist__tab--active' : 'tablist__tab'} onClick={() => handleTabClick(tab)}><span>{tab.title}</span>
                        {
                            owner && <img src={EditPen} onClick={(e) => handleTabNameEdit(e, tab.id, tab.title)} alt="edit" />
                        }
                    </button>)
                }
                {
                    owner && <button onClick={handleAddNewTab} className='tablist__action-btn'>Add +</button>
                }
            </div>
            {
                owner && <div>
                    {
                        activeTabDetails && <button onClick={handleUploadInTab} className='tablist__action-btn tablist__action-btn--upload-btn'>
                            <img src={UploadIcon} alt="upload" /> <span id='tablist__long-title'>Upload in  {activeTabDetails.title}</span>
                        </button>
                    }
                </div>
            }
        </div>
    )
}

export default Tablist